import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    key: "index",
    customRender: (value, item, index) => {
      return index + 1;
    },
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    key: "material_name",
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    key: "material_number",
  },
  {
    title: T("库存数量"),
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: T("可用数量"),
    dataIndex: "available_quantity",
  },
  {
    title: T("单位"),
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: T("操作"),
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
